import { render, staticRenderFns } from "./new-widget.vue?vue&type=template&id=1efd0c04&"
import script from "./new-widget.vue?vue&type=script&lang=js&"
export * from "./new-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports